import React from 'react'
import { ErrorPopupSc } from './error.styled'

interface ErrorProps {
  children: React.ReactNode
}

const Error: React.FC<ErrorProps> = ({ children }) => {
  return <ErrorPopupSc>{children}</ErrorPopupSc>
}

export default Error
